import 'bootstrap';
import './vendor/configs';
import './vendor/lazy';
import './vendor/carousels';
import './vendor/banners';
import './vendor/gallery';
import './vendor/video';
import './vendor/poll';
import './vendor/comments';
import './vendor/promotion';
import './vendor/share';
import './vendor/mask';
import './vendor/goto';
import './vendor/adverts';
import './vendor/header';
import './vendor/search';
import './vendor/menu';
import './vendor/view-register';
import '../../../supports/assets/js/vendor/combo-box-city';
